import React, { useEffect, useState } from 'react'
import RouteManager from '../../../../../managers/RouteManager';
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from '../../../../../managers/TableManger';
import { fetchProfessionalTaxDetails, selectProfessionalTaxReportDetails } from '../../../../../Redux/Slices/StatutoryReportSlice';
import { EpfTaxReportColumnConfig, EsiTaxReportColumnConfig, parseColumnConfig, ProfessionalTaxReportColumnConfig } from '../../../../configs/config';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Utility, { deepClone } from '../../../../../utility/Utility';
import DataGridHolderPayroll from '../../../../common/DataGridHolderPayroll';
import StatutoryReportFieldService from '../../../../../services/StatutoryReportFieldService';
import { DKLabel, DKButton, showToast, TOAST_TYPE, DKSpinner, INPUT_TYPE, DKCalendar, DKIcon, DKIcons, DKLine, DKInput, INPUT_VIEW_DIRECTION, Toggle,showLoader,removeLoader } from "deskera-ui-library";
import PayrollService from '../../../../../services/PayrollService'
import ReportService from '../../../../../services/ReportService';
import { saveAs } from 'file-saver';
import i18next from 'i18next';
import { STATUTORY_CONSTANT } from '../../../ReportsConstants';



const StatutoryReport = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    let FORM_TYPE = ''
    if(props?.match?.params && props.match.params.form) {
        FORM_TYPE = props.match.params.form;
    }
    const dispatch = useDispatch();
    const reportData = useSelector(selectProfessionalTaxReportDetails);

    const [report, setReport] = useState(initialState);
    const [refresh, setRefresh] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [userList, setUserList] = useState([]);
    const [forAllEmployee, setForAllEmployee] = useState(false);
    const [reload, setReload] = useState(false);

    const [param, setSelectedParam] = useState({
        month: moment().subtract(1, 'month').format('MMMM'),
        years: moment().year(),
        page: 1,
        limit: 20,
        employees: []
    });


    useEffect(() => {
        RouteManager.setPresenter({ props });
        /* API Calls Start */
        showLoader()
        getUsers()
        setSelectedParam({ ...param, years: getYears() })
        loadProfessionalTaxForm(StatutoryReportFieldService.defaultConfig);
        /* API Calls End */
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(reportData)) {
            let rowData ;
            let reportColumn; 
            switch(FORM_TYPE ) {
                case STATUTORY_CONSTANT.EPF.type:
                    rowData = EpfTaxReportColumnConfig(reportData[STATUTORY_CONSTANT[FORM_TYPE].report]);
                    reportColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_EPF_TAX_REPORT));
                    break;
                case STATUTORY_CONSTANT.PT.type:
                    rowData = ProfessionalTaxReportColumnConfig(reportData[STATUTORY_CONSTANT[FORM_TYPE].report]);
                    reportColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_PROFSESSION_TAX_REPORT));
                    break;
                case STATUTORY_CONSTANT.ESI.type:
                    rowData = EsiTaxReportColumnConfig(reportData[STATUTORY_CONSTANT[FORM_TYPE].report]);
                    reportColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_ESI_TAX_REPORT));
                    break;
                default:
                    rowData = []
                    reportColumn = []
            }
            
            const filterResponse = reportData.filterResponse;

            const passingData = {
                columnData: deepClone(reportColumn),
                rowData,
                filter: [],
                originalData: reportData[STATUTORY_CONSTANT[FORM_TYPE].report]
            };
            setReport(passingData)
            if (!Utility.isEmpty(reportData[[STATUTORY_CONSTANT[FORM_TYPE].report]])) {
                setTotalPageCount(filterResponse.totalPages);
                setCurrentPage(+filterResponse?.currentPage);
                setTotalCount(filterResponse.count)
            }

        }

    }, [reportData,reload])

    const loadProfessionalTaxForm = async (param) => {
        showLoader()
        try {
            StatutoryReportFieldService.apiConfig = {
                ...param,
                form: FORM_TYPE
            };
            await dispatch(fetchProfessionalTaxDetails())

        } catch (err) {
            console.error('Error loading report data: ', err);

        }
    }

    const getUsers = async () => {

        const response = await PayrollService.getUsersList();
        if (response['status'] == 'OK') {
            console.log(response['users']);
            setUserList(response['users'])
        }
    }

    const getYears = () => {
        if (moment().month() == 0) {
            return moment().subtract(1, 'years').year()
        }
        return moment().year()
    }

    const onFetch = () => {
        let from = param.years + "-" + moment().month(param.month).format("MM") + "-01"
        let config = {
            from: from,
            to: moment(moment(from).format()).endOf('month').format('YYYY-MM-DD'),
            form: FORM_TYPE,
            employeeId: param.employees,
            filterOptions: {
                currentPage: param.page,
                limit: param.limit
            }
        }
        loadProfessionalTaxForm(config)
    }

    const exportForm = () => {
        let config = {
            month: moment().month(param.month).format("MM"),
            year: param.years,
            form: FORM_TYPE,
            employeeId: param.employees
        }
        showLoader();
        ReportService.exportStatutoryReport(config).then(
            (response) => {
                removeLoader();
                const csvData = new Blob([response], { type: 'text/csv;charset=utf-8;' });

                saveAs(csvData, `${FORM_TYPE}_${param.month}${STATUTORY_CONSTANT[FORM_TYPE].downloadFileType}`);
                showToast(i18next.t("DOWNLOAD_COMPLETED"), TOAST_TYPE.SUCCESS);
            }, (error) => {
                removeLoader();
                showToast(i18next.t("ERROR_DOWNLOAD"), TOAST_TYPE.FAILURE);
            }
        )
    }

    const getSelectedEmployees = () => {
        let users = []
        userList.filter((obj, index)=> { param.employees.forEach(id => {
            if (obj.iamUserId == id){
                users.push(index)
            }
        }) })
        return users
    }


    return (
        <div className="parent-width parent-height">
            <DKLabel text={i18next.t(STATUTORY_CONSTANT[FORM_TYPE].title)} className="fw-m fs-l" />
            <div className="bg-white pb-l card-shadow mt-l">
                <DKLabel text={i18next.t(STATUTORY_CONSTANT[FORM_TYPE].cardTitle)} className="fw-m fs-l p-l" />
                <DKLine className="bg-gray3  " />
                <div className="d-flex mt-s row row-responsive">
                    <div className="p-h-l web-width-30 d-flex" >
                        <div className="web-width-70">
                            <DKInput
                                title={i18next.t("MONTH")}
                                value={param.month}
                                formatter={(obj) => {
                                    return obj;
                                }}
                                className=""
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={true}
                                options={moment.months()}
                                onChange={(value) => {
                                    param.month = value
                                    param.page = 1
                                    setSelectedParam(param)
                                }}
                                dropdownConfig={{

                                    data: moment.months(),
                                    renderer: (index, obj) => {
                                        return <DKLabel className="" text={obj} />;
                                    },
                                }}
                            />
                        </div>
                        <div className="web-width-70 ml-l">
                            <DKInput
                                title={i18next.t("YEAR")}
                                value={param.years}
                                formatter={(obj) => {
                                    return obj;
                                }}
                                className=""
                                type={INPUT_TYPE.DROPDOWN}
                                showError={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                required={true}
                                canValidate={true}
                                options={[moment().year(), moment().subtract(1, 'years').year()]}
                                onChange={(value) => {
                                    param.years = value
                                    param.page = 1
                                    setSelectedParam(param)

                                }}
                                dropdownConfig={{
                                    data: [moment().year(), moment().subtract(1, 'years').year()],
                                    renderer: (index, obj) => {
                                        return <DKLabel className="" text={obj} />;
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex web-width-30 justify-content-center " style={{ marginTop: '30px' }}>
                        <DKLabel
                            className="text-align-left ml-s mr-l"
                            text={i18next.t("ALL_EMPLOYEE")}
                        />
                        <Toggle
                            className="border-n"
                            isOn={forAllEmployee}
                            onChange={() => {
                                if (forAllEmployee) {
                                    setSelectedParam({ ...param, employees: [] })
                                }
                                setForAllEmployee(!forAllEmployee)
                            }}
                        />
                        <DKLabel
                            className="text-align-left ml-l mr-l fw-m"
                            text={i18next.t("SPECIFIC_EMPLOYEE")}
                        />
                    </div>
                    <div className="web-width-30 mobile-horizontal-width padding-top-mobile">
                        {(forAllEmployee && userList.length === 0) && <div style={{ marginLeft: "-279px", marginBottom: "-13px" }}><DKSpinner className="" /></div>}

                        <DKInput
                            title={i18next.t("EMPLOYEE")}
                            value={getSelectedEmployees()}
                            type={INPUT_TYPE.MULTI_SELECT}
                            required={false}
                            canValidate={false}
                            readOnly={!forAllEmployee}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={userList.map(res => `${res.firstName} ${res.lastName}`)}
                            errorMessage={i18next.t("PLEASE_SELECT_EMPLOYEE")}
                            onChange={(value) => {
                                param.employees = value.map(i => parseInt( userList[i].iamUserId) )                                // param.employees.push(parseInt(userList[value].iamUserId))
                            }}
                        />
                    </div>
                    <div className="mb-xs ml-l" style={{ marginTop: '24px' }}>
                        <DKButton
                            title={i18next.t('FETCH')}
                            className="bg-app text-white"
                            onClick={() => {
                                onFetch();
                            }}
                        />
                    </div>
                    <div className="mb-xs m-h-l" style={{ marginTop: '24px' }}>
                        <DKButton
                            title={i18next.t("EXPORT")}
                            icon={DKIcons.white.ic_export}
                            className="bg-app text-white"
                            onClick={() => {
                                exportForm()
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="column parent-width flex-1 " style={{height:"80%"}}> 
                <div className="column parent-width mb-s position-relative flex-1 ">

                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_PROFSESSION_TAX_REPORT}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_PROFSESSION_TAX_REPORT]}
                        allowRowEdit={false}
                        allowColumnEdit={false}
                        allowRowAdd={true}
                        allowColumnAdd={false}
                        allowColumnDelete={true}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        addButtonConfig={[{
                        }]}
                        allowDataExport={true}
                        gridData={report}
                        filter={report.filterResponse}
                        onPaginationClick={(requestedPageNumber) => {
                            param.page = requestedPageNumber
                            setSelectedParam(param)
                            onFetch()
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={false}
                        contextMenu={false}
                        allowColumnSort={false}
                        formType={FORM_TYPE}
                        onColumnShift={(data)=>setReload(!reload)}
                    />
                </div>
            </div>
        </div>
    )
}

export default StatutoryReport
